// @core/api/endpoints/platform/resolve_federated_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveFederatedResourceResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Resolve federated resource
 * Resolves a URN from a federated platform to its cached preview. If the cache is expired, fetches from the remote platform (subject to data residency policy).
 */
export async function ResolveFederatedResource(
  params?: {
  },
  options?: RequestOptions
): Promise<ResolveFederatedResourceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/federation/resolve`;
  const requestOptions = options;
  return client.get<ResolveFederatedResourceResponse>(requestPath, { ...requestOptions, params });
}
